import { useExternalRolesQuery } from './useExternalRolesQuery';
import { useExternalRoleUserCountsQuery } from './useExternalRoleUserCountsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CreateExternalRoleMutationParams {
  name: string;
  description?: string;
  permissions?: string[];
}

export const useExternalRoleCreateMutation = createMutationHook(
  'settings.customerPortal.createRole',
  (params: CreateExternalRoleMutationParams) => ({
    coreRoleCreate: {
      __args: {
        input: {
          name: params.name,
          description: params.description,
          permissions: params.permissions,
          type: 'EXTERNAL' as const,
        },
      },
      id: true,
      name: true,
      description: true,
      permissions: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
  {
    invalidateQueries: [useExternalRolesQuery, useExternalRoleUserCountsQuery],
  },
);
